// @ts-check
/* eslint-env browser */

import { openExtractionExportDialog } from './extraction-export-dialog.js'

/** @typedef {'csv' | 'geojson' | 'shapefile' | 'geotiff'} ExportFormat */

/**
 * Wraps an export button and opens the shared export dialog on click.
 *
 * Usage:
 *   <extraction-export-button job-ids='["job-id"]'>
 *     <button type="button" class="govuk-button">Export data</button>
 *   </extraction-export-button>
 */
class ExtractionExportButton extends HTMLElement {
  connectedCallback () {
    const button = this.querySelector('button, a')
    if (!button) {
      console.warn('extraction-export-button: No button found inside component')
      return
    }

    button.addEventListener('click', (event) => {
      event.preventDefault()
      const jobIds = JSON.parse(this.getAttribute('job-ids') ?? '[]')
      const formats = /** @type {ExportFormat[]} */ ((this.getAttribute('formats') ?? '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean))
      openExtractionExportDialog({
        jobIds,
        formats
      })
    })
  }
}

customElements.define('extraction-export-button', ExtractionExportButton)
